const obj = {
  new_york: 'New York',
  london: 'London',
};

export default obj;
